import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import theme from '@/theme'
import { switchTenant } from '@/redux/ducks/user/info'
import ThemeInterface from '@/theme-interface'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconRedirect from 'assets/images/icons/redirect.svg'
import { showLoader, hideLoader, closeTenantSelection } from '@/redux/ducks/tenant/selection'
import TenantSelectionItemActive from '@/modules/base/components/tenant-selection/items/tenant-selection-active-item'
import { ColorModes } from '@/modules/layout/constants'
import { useNavigate } from 'react-router'
import { useAppDispatch } from '@/redux/store'

interface TenantSelectionHeaderProps {
  showBackToTaxOffice: boolean
  companyName: string,
  taxOfficeTenantId: string
}

const defaultProps = {
  showBackToTaxOffice: false,
  companyName: lang.tenant.selection.defaultCompanyName,
  taxOfficeTenantId: null,
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    background: theme.mode.backgroundColor.medium,
    color: theme.mode.color.default,
  },
  seperator: {
    borderBottom: `1px solid ${theme.mode.borderColor.medium}`,
    opacity: theme.mode.type === ColorModes.dark ? 0.2 : 1.0,
  },
  taxConsultant: {
    padding: 30,
    paddingBottom: 20,
  },
  activeItem: {
    padding: '15px 30px',
  },
  companyName: {
    fontSize: theme.fontSizes.smedium,
    fontWeight: theme.fontWeights.medium,
  },
  redirect: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.fontSizes.smaller,
    color: theme.primary,
    cursor: 'pointer',
    '&:hover': {
      fontWeight: theme.fontWeights.medium,
    },
  },
  redirectLabel: {
    marginRight: 7,
  },
}), { name: 'TenantSelectionHeader' })

const TenantSelectionHeader = (props: TenantSelectionHeaderProps = defaultProps) => {
  const navigate = useNavigate()
  const classes = useStyles()
  const dispatch = useAppDispatch()
  const { showBackToTaxOffice, companyName, taxOfficeTenantId } = props

  const displayName = useMemo(() => {
    return companyName || defaultProps.companyName
  }, [companyName])

  const switchToTaxConsultant = (): void => {
    dispatch(showLoader())
    dispatch(closeTenantSelection())
    dispatch(switchTenant({ tenantId: taxOfficeTenantId }, () => {
      navigate('/')
      dispatch(hideLoader())
    }))
  }

  return (
    <div className={classes.root}>
      <div className={classes.taxConsultant}>
        <span className={classes.companyName}>{displayName}</span>
        {showBackToTaxOffice && <div className={classes.redirect} onClick={switchToTaxConsultant}>
          <span className={classes.redirectLabel}>{lang.tenant.selection.backToTaxOffice}</span>
          <SVGIcon svg={IconRedirect} height="13px" width="13px" fill={theme.primary} />
        </div>
        }
      </div>
      <div className={classes.seperator} />
      <div className={classes.activeItem}><TenantSelectionItemActive /></div>
      <div className={classes.seperator} />
    </div>
  )
}

export default TenantSelectionHeader
